import React, {useEffect, useRef, useState} from "react";
import fields from "./config/FormatBasicDataFormConfig";
import CardForm from "../../components/form/CardForm";
import {Actions} from "../../../client/Actions";
import {Row} from "react-bootstrap";
import FormatFilesFormConfig from "./config/FormatFilesFormConfig";
import FormatTabletSizeFormConfig from "./config/FormatTabletSizeFormConfig";
import BlisteringMachineDataFormConfig from "./config/BlisteringMachineDataFormConfig";
import ConfirmModal from "../../components/modal/ConfirmModal";
import {MiniNavigation} from "../../components/nav/MiniNavigation";
import utils from "../../helpers/utils";
import { useTranslation } from 'react-i18next';


const FormatData = ({formatId, format, setLoader, onSaved}) => {
    const basicDataRef = useRef(null);
    const filesRef = useRef(null);
    const blisterRef = useRef(null);

    const { t } = useTranslation();

    const sections = [
        {ref: basicDataRef, name: "basicData", menu: t("forms.basic_data")},
        {ref: filesRef, name: "files", menu: t("forms.files")},
        {ref: blisterRef, name: "blister", menu: t("forms.blisters")},
    ];


    const [formatData, setFormatData] = useState({});
    const [blisteringData, setBlisteringData] = useState({});
    const [executeSave, setExecuteSave] = useState(false);
    const [executeCancel, setExecuteCancel] = useState(false);
    const [showAllerModal, setShowAllerModal] = useState(false);
    const [basicValid, setBasicValid] = useState(false);
    const [tabletSizeValid, setTabletSizeValid] = useState(true);
    const [filesValid, setFilesValid] = useState(false);
    const [blisterValid, setBlisterValid] = useState(false);
    const [dictionaries, setDictionaries] = useState();

    const saveFormat = () => {
        setLoader(true);
        Actions.post("format", formatData, saveBlisteringData);
    };

    const saveBlisteringData = () => {
        Actions.post(`format/` + formatId + "/blisteringMachineData", blisteringData, onSaved);
    };

    const formatDataUpdated = (updated) => {
        if (updated) {
            const tmp = {...formatData};
            Object.keys(updated).forEach((key) => (tmp[key] = updated[key]));
            setFormatData(tmp);
        }
    };

    const clearData = () => {
        const tmp = {id: formatId};
        setFormatData(tmp);
        setBlisteringData({});
    };

    const formValidationFailed = (setValidFunction) => {
        setShowAllerModal(true);
        setValidFunction(false);
    };

    const blisteringDataUpdated = (updated) => {
        if (updated) {
            const tmp = {...blisteringData};
            Object.keys(updated).forEach((key) => (tmp[key] = updated[key]));
            setBlisteringData(tmp);
        }
    };


    const dataCompleted = (setValidFunction) => {
        setValidFunction(true);
    };

    const validationUpdated = () => {
        const valid = basicValid && tabletSizeValid && filesValid && blisterValid;
        console.log("Validation results:", {
            "Basic Valid": basicValid,
            "Tablet Size Valid": tabletSizeValid,
            "Files Valid": filesValid,
            "Blister Valid": blisterValid,
            "Overall Valid": valid
        });
        if (valid) {
            saveFormat();
        }
    };

    const loadMachineModels = () => {
        Actions.get("machine-model", prepareMachineTypes)
    };

    const prepareMachineTypes = (machineModels) => {
        if (machineModels) {
            const tmp = {};
            console.log("exists: ", utils.unique(machineModels.filter(m => m.formatPartsCount > 0).map(m => m.machineType)))
            console.log("not exists: ", utils.unique(machineModels.filter(m => m.formatPartsCount === 0).map(m => m.machineType)))
            tmp["enums/machineType"] = utils.unique(machineModels.filter(m => m.formatPartsCount > 0).map(m => m.machineType));
            setDictionaries(tmp);
        }
    };


    useEffect(() => formatDataUpdated({id: formatId}), [formatId]);
    useEffect(() => {
        if (executeSave) {
            setExecuteSave(false);
        }
    }, [executeSave]);

    useEffect(() => {
        if (executeCancel) {
            setExecuteCancel(false);
            clearData();
        }
    }, [executeCancel]);

    useEffect(validationUpdated, [basicValid, tabletSizeValid, filesValid, blisterValid]);
    useEffect(loadMachineModels, []);


    return (
        <>
            {/* Top Menu */}
            <MiniNavigation
                defaultSection={"basicData"}
                sections={sections}
            />

            {/* Sections */}
            <Row ref={basicDataRef}>
                {dictionaries &&
                    <CardForm
                        setLoader={setLoader}
                        fields={fields}
                        width={6}
                        className={"mt-2"}
                        withoutHeader={true}
                        initialData={format}
                        dictionaries={dictionaries}
                        readOnly={!!format}
                        noActions={true}
                        executeSave={executeSave}
                        executeCancel={executeCancel}
                        disableLoader={true}
                        disableInvalidAlert={true}
                        customSave={(data) => dataCompleted(setBasicValid)}
                        onInvalid={() => formValidationFailed(setBasicValid)}
                        formDataChanged={formatDataUpdated}
                    />
                }
                {(formatData.tabletType === "TABLET" || format?.tabletType === "TABLET") && (
                    <CardForm
                        setLoader={setLoader}
                        fields={FormatTabletSizeFormConfig}
                        width={6}
                        initialData={format}
                        title={t("forms.tablet_dimensions")}
                        className={"mt-2"}
                        readOnly={!!format}
                        noActions={true}
                        executeSave={executeSave}
                        executeCancel={executeCancel}
                        disableInvalidAlert={true}
                        disableLoader={true}
                        customSave={(data) => dataCompleted(setTabletSizeValid)}
                        onInvalid={() => formValidationFailed(setTabletSizeValid)}
                        formDataChanged={formatDataUpdated}
                    />
                )}
            </Row>

            <Row ref={filesRef}>
                <CardForm
                    setLoader={setLoader}
                    fields={FormatFilesFormConfig}
                    width={12}
                    initialData={format}
                    className={"mt-2 "}
                    withoutHeader={true}
                    readOnly={!!format}
                    noActions={true}
                    executeSave={executeSave}
                    executeCancel={executeCancel}
                    disableInvalidAlert={true}
                    disableLoader={true}
                    customSave={(data) => dataCompleted(setFilesValid)}
                    onInvalid={() => formValidationFailed(setFilesValid)}
                    formDataChanged={formatDataUpdated}
                />
            </Row>

            <Row ref={blisterRef}>
                <CardForm
                    setLoader={setLoader}
                    fields={BlisteringMachineDataFormConfig(t)}
                    width={12}
                    title={t("forms.blisters")}
                    readOnly={!!format}
                    initialData={format?.blisteringMachineData}
                    className={"mt-2 "}
                    noActions={true}
                    executeSave={executeSave}
                    executeCancel={executeCancel}
                    disableInvalidAlert={true}
                    customSave={(data) => dataCompleted(setBlisterValid)}
                    onInvalid={() => formValidationFailed(setBlisterValid)}
                    disableLoader={true}
                    formDataChanged={blisteringDataUpdated}
                />
            </Row>

            {!format && (
                <Row>
                    <CardForm
                        setLoader={setLoader}
                        fields={{fields: []}}
                        width={12}
                        withoutHeader={true}
                        className={"mt-2 "}
                        disableLoader={true}
                        customSave={() => setExecuteSave(true)}
                        postCancel={() => setExecuteCancel(true)}
                    />
                </Row>
            )}

            <ConfirmModal
                title={t("forms.all_fields_required")}
                description={t("forms.fill_red_fields")}
                size={"md"}
                show={showAllerModal}
                setShow={setShowAllerModal}
                alert
                onConfirm={() => setShowAllerModal(false)}
            />
        </>
    );
};

export default FormatData;
